import React, { Suspense, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PageLoader from '@/components/PageLoader';
import CSNavbar from './CSNavbar';
import VacationBanner from './VacationBanner';
import { useCart } from '@/context/CartContext';
import CookieBanner from '@/components/CookieBanner';

// Le panier (et sa dépendance framer-motion) n'est chargé qu'à la 1re ouverture,
// ce qui retire framer-motion du bundle d'entrée. Reste monté ensuite pour
// préserver les animations d'entrée/sortie.
const CSCartSlideout = React.lazy(() => import('./CSCartSlideout'));
// Le footer (sous le fold, formulaire newsletter) est lazy pour rester hors du
// bundle critique et accélérer le 1er rendu (FCP/LCP) sur mobile.
const CSFooter = React.lazy(() => import('./CSFooter'));

export default function CSLayout() {
  const { isOpen } = useCart();
  const [everOpened, setEverOpened] = useState(false);
  useEffect(() => { if (isOpen) setEverOpened(true); }, [isOpen]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <CSNavbar />
      <VacationBanner />
      {everOpened && (
        <Suspense fallback={null}>
          <CSCartSlideout />
        </Suspense>
      )}
      <main className="flex-1">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <CSFooter />
      </Suspense>
      <CookieBanner />
    </div>
  );
}